import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators, ValidatorFn } from '@angular/forms';
import {MomentDateAdapter} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import { HttpClient, HttpRequest } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import * as _moment from 'moment';
import { FormData } from 'form-data';
import {AppComponent} from '../../app.component';
import { AlertService } from '../../alertpopup/_alert';
export const MY_FORMATS = {
  parse: { dateInput: 'DD-MMM-YYYY' },
  display: {
    dateInput: 'DD-MMM-YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
    selector: 'app-add-masters',
    templateUrl: './add-masters.component.html',
    styleUrls: ['./add-masters.component.css'],
    providers: [
        // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
        // application's root module. We provide it at the component level here, due to limitations of
        // our example generation script.
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    ],
    standalone: false
})
export class AddMastersComponent implements OnInit {
  @Input() formData: FormData[];
  form: FormGroup;
  submitted: boolean;
  minDate = new Date(1990, 0, 1);
  maxDate = new Date(2030, 0, 1);
  pageurl: string;
  url: string;
  MGenID: any;
  SubMGenID: any;
  buttonName: string;
  ID: any;
  RightsID: string;
  options = {
    autoClose: true,
    keepAfterRouteChange: false
  };
constructor(private router: Router, private http: HttpClient, private formBuilder: FormBuilder, protected alertService: AlertService) { this.url = AppComponent.baseURL; }

  ngOnInit() {
    this.RightsID = localStorage.getItem('UserRight');
    if (this.RightsID.includes('202042001') || this.RightsID.includes('202042021') ) {
    } else {
      window.location.href = "module/0";
    }
    this.pageurl = this.router.url;
    let pagehead = this.pageurl.split('/');
    this.MGenID = pagehead[2];
    this.SubMGenID = pagehead[3];
    const formGroup = {};
    this.form = new FormGroup(formGroup);
    this.buttonName = "Submit";
   // this.form = this.formBuilder.group({ ID:['']});
    this.http.get(this.url + 'GM/GetMasterDesign?GenID=' + this.MGenID + '&subID=' + this.SubMGenID)
    .subscribe( (res) => {
      this.formData = JSON.parse(res.toString());
      const formGroup: { [key: string]: FormControl } = {};
        this.formData.forEach(fc => {
          const validators = this.buildValidators(fc.validators);
          formGroup[fc.controlName] = new FormControl(
            fc.selectedValue ?? '',
            validators
          );
        });

        this.form = new FormGroup(formGroup);
        if (this.SubMGenID > 0 ) {
          this.buttonName = "Update";
      }
      } );
  }
  submitForm() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.submitted = true;
    this.http.post(this.url + 'GM/InsertUpdateGetMaster', this.form.value).subscribe( (data) =>   {
        if (data == null) {
          this.alertService.showError('Check Your InterNet Connection, Try Again Later');
        } else {
          if (this.SubMGenID > 0 ) {
            this.alertService.showSuccess('Master Updated Successfully');
          }
          else{
            this.alertService.showSuccess('Master Added Successfully');
          }

        }
       }
    );
  }

  private buildValidators(v: any): ValidatorFn[] {
  const validators: ValidatorFn[] = [];

  if (!v) return validators;

  if (v.required) {
    validators.push(Validators.required);
  }

  if (v.minlength && v.minlength > 0) {
    validators.push(Validators.minLength(v.minlength));
  }

  if (v.maxlength && v.maxlength > 0) {
    validators.push(Validators.maxLength(v.maxlength));
  }

  return validators;
}
}
